<template>
  <div class="history-wrapper">
    <div v-if="!userHistory || !userHistory.data" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading user history...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <!-- History Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
        <HistoryRecords :records="userHistory.data" />
      </div>
    </div>
  </div>
</template>

<script>
  import HistoryRecords from './UserHistory'
  import { mapGetters } from 'vuex'

  export default {
    name: 'History',
    components: {
      HistoryRecords
    },
    props: {
      username: { type: String, required: true }
    },
    computed: mapGetters({
      userHistory: 'userHistory'
    }),
    watch: {
      username: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username) {
          this.emit('getUserHistory', this.username)
        }
      }
    }
  }
</script>
